module.exports = __webpack_public_path__ + "static/media/jetty-welcome-cropped.454c0115.jpg";